import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { fmtDT } from "@/lib/qr";

const TOGGLES = [["personal", "QR personale (profil / shokë)"], ["transfer", "Dërgim GjejKredit me QR"], ["visits", "Vizita në biznes"], ["offers", "Oferta dhe dhurata të bizneseve"]];
const NUMS = [["radius_m", "Distanca maks. nga lokali (metra)"], ["visit_cooldown_h", "Një vizitë për biznes çdo (orë)"], ["max_visit_points", "Maks. kredite që biznesi jep për vizitë"],
  ["personal_ttl", "QR personale vlen (sekonda)"], ["live_ttl", "QR live e biznesit vlen (sekonda)"], ["offer_ttl", "QR e ofertës vlen (sekonda)"]];
const TYPE = { visit: "Vizitë", transfer: "Transferim", offer: "Ofertë" };

export default function AdminQr() {
  const [d, setD] = useState(null);
  const [f, setF] = useState(null);
  const load = () => api.get("/admin/qr").then((r) => { setD(r.data); setF(r.data.config); }).catch(() => setD(false));
  useEffect(() => { load(); }, []);
  if (d === false) return <div className="p-6 text-center text-sm text-slate-500">Nuk u ngarkua.</div>;
  if (!d) return <div className="p-6 text-center text-sm text-slate-500">Duke ngarkuar...</div>;
  const save = async () => { try { await api.put("/admin/qr", f); toast.success("Rregullat e QR u ruajtën"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-3" data-testid="admin-qr">
      <div className="bg-white rounded-2xl p-3 border border-slate-100 space-y-2">
        <div className="text-sm font-bold text-slate-900">Funksionet e QR</div>
        {TOGGLES.map(([k, l]) => <label key={k} className="flex items-center gap-2 text-sm text-slate-700"><input data-testid={`aq-${k}`} type="checkbox" checked={!!f[k]} onChange={(e) => setF({ ...f, [k]: e.target.checked })} className="accent-emerald-600 w-4 h-4" />{l}</label>)}
        <div className="grid grid-cols-2 gap-2 pt-1">
          {NUMS.map(([k, l]) => <label key={k} className="text-[11px] text-slate-500">{l}<input data-testid={`aq-${k}`} type="number" min="0" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="w-full h-10 rounded-xl border border-slate-200 px-3 text-sm" /></label>)}
        </div>
        <button data-testid="aq-save" onClick={save} className="w-full h-10 rounded-xl bg-emerald-500 text-white text-sm font-bold">Ruaj rregullat</button>
      </div>
      <div className="bg-white rounded-2xl p-3 border border-slate-100 space-y-1.5" data-testid="aq-transactions">
        <div className="text-sm font-bold text-slate-900">Transaksionet QR ({d.transactions.length}) · {d.offers} oferta</div>
        {d.transactions.map((t) => (
          <div key={t.tx_id} className="text-xs text-slate-600 border-b border-slate-50 pb-1.5" data-testid={`aq-tx-${t.tx_id}`}>
            <b>{TYPE[t.type]}</b> · <span translate="no">{t.user_name}{t.to_user_name ? ` → ${t.to_user_name}` : ""}{t.business_name ? ` @ ${t.business_name}` : ""}</span>{t.offer_name ? ` · ${t.offer_name}` : ""}
            {t.points ? ` · ${t.points > 0 ? "+" : ""}${t.points} kredite` : ""}{t.distance_m != null ? ` · ${t.distance_m} m` : ""}
            <div className="text-[10px] text-slate-400">{fmtDT(t.created_at)} · ID {t.tx_id}</div>
          </div>
        ))}
        {!d.transactions.length && <p className="text-xs text-slate-400">Ende asnjë transaksion.</p>}
      </div>
    </div>
  );
}
